module.exports = __webpack_public_path__ + "img/1.1d2aa050.png";